import * as d3 from 'd3';
d3.formatDefaultLocale({
  decimal: '.',
  thousands: ',',
  grouping: [3],
  currency: ['$', ''],
  minus: '-',
});
export default d3;
